import React, { useEffect, useState } from "react";
import Parse from "../../api/ApiConfig";
import { useOutletContext, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { FormContainer } from "../../components/Form/FormComponents.styled";
import { fetchSingleObject } from "./utils";
import SubmittedForm from "./sections/SubmittedForm";
import CompletedForm from "./sections/CompletedForm";
import SavingsForm from "./sections/SavingsForm";
import { fetchSavingsObject } from "../lease/utils";

/* eslint-disable no-unused-vars */
const SingleTVA = () => {
	let { category, id: requestId } = useParams();
	const [loading, setLoading] = useOutletContext();
	const [objectData, setObjectData] = useState(null);

	const getCurrentObject = async () => {
		let data;
		// Fetch Lease object
		if (category === "savings") {
			data = await fetchSavingsObject(requestId);
		} else {
			data = await fetchSingleObject(requestId);
		}

		// Handle response data
		if (data && !data?.error) {
			setLoading(false);
			// console.log(data);
			setObjectData(data.result);
		} else {
			setLoading(false);
			setObjectData(data);
			toast.error(data?.error || "Error fetching data!");
		}
	};

	const updateCurrentObject = async (formData) => {
		setLoading(true);
		try {
			let ParseObj = Parse.Object.extend("TravelAdvance");
			const parseObject = new ParseObj();
			parseObject.id = requestId;

			// Save A.F data
			parseObject
				.save({
					type: formData.type,
					amountToRaise: formData.amountToRaise,
					expectedProfit: formData.expectedProfit,
					duration: formData.duration,
					interestRate: formData.interestRate,
					programSavings: formData.programSavings,
					businessType: formData.businessType,
					businessDescription: formData.businessDescription,
					purpose: formData.purpose,
					approvalStatus: formData.approvalStatus,
				})
				.then((result) => {
					console.log("parseObject updated:", result);
					setLoading(false);
					toast.success("Object updated successfully!");
				});
		} catch (error) {
			console.log(error);
			setLoading(false);
			toast.error("Error updating Object!");
		}
	};

	// On page load
	useEffect(() => {
		setLoading(true);
		getCurrentObject();
	}, []);

	// console.log(category);
	const CurrentPageForm = (props) => {
		switch (category) {
			case "submitted":
				return <SubmittedForm {...props} />;
			case "completed":
				return <CompletedForm {...props} />;
			case "savings":
				return <SavingsForm {...props} />;

			default:
				return <div className='text-center p-3'>[404] Error: Category not found!</div>;
		}
	};

	console.log(category);

	return (
		<FormContainer>
			{
				// Show CurrentPageForm if requestId is present and loading is false
				objectData && !loading ? (
					<CurrentPageForm
						objectData={objectData}
						setObjectData={setObjectData}
						updateCurrentObject={updateCurrentObject}
					/>
				) : objectData?.error ? (
					<div className='text-center fw-500 p-3'>Error fetching data!</div>
				) : null
			}
		</FormContainer>
	);
};

export default SingleTVA;
